<template>
  <div class="max-w-screen-2xl mx-auto px-4 flex relative flex-wrap w-full py-8 border-b-2 border-[#4C535966] mt-2 md:mt-4">
    <div class="w-full">
      <h2 class="font-secondary text-2xl md:text-3xl mb-8">{{ tr('Emergency Contact') }}</h2>
    </div>
    <div class="w-full grid md:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-4 items-end">
      <div v-for="field in fields" :key="field.key" class="mb-5">
        <label class="block mb-2 text-sm font-medium text-gray uppercase">
          {{ tr(field.label) }}<span v-if="field.required" class="ml-2 text-primary">*</span>
        </label>
        <input
          :type="field.type || 'text'"
          :value="modelValue[field.key]"
          :class="{ error: errors[field.key] }"
          :disabled="disabled"
          :readonly="disabled"
          class="bg-light-gray border border-[#ADAEAE] text-gray text-sm rounded-lg focus:border-[#ADAEAE] focus:ring-transparent outline-none block w-full p-3"
          @input="updateField(field.key, $event.target.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookingFormEmergencyContact',
  props: {
    modelValue: { type: Object, required: true },
    errors: { type: Object, required: true },
    disabled: Boolean
  },
  emits: ['update:modelValue'],
  data () {
    return {
      fields: [
        { key: 'fullName', label: 'Full name', required: true },
        { key: 'relationship', label: 'Relationship', required: true },
        { key: 'primaryPhone', label: 'Main telephone number with country/area code', required: true },
        { key: 'secondaryPhone', label: 'Secondary phone' },
        { key: 'email', label: 'Email address', type: 'email', required: true }
      ]
    };
  },
  methods: {
    updateField (key, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
    },
    tr (key) {
      return this.$root.tr(key);
    }
  }
};
</script>

<style scoped>
.error {
  border: 2px solid red;
}
</style>
